import { isAuthEnforced } from "@/lib/supabase/client";
import { useAuthStore } from "@/stores/auth-store";

/**
 * Resolve where an authenticated (or demo) user should land.
 */
export function resolveHomePath(): "/app/today" | "/onboarding" | "/welcome" {
  const { status, isOnboardingComplete } = useAuthStore.getState();

  if (!isAuthEnforced() || status === "demo") {
    return "/app/today";
  }

  if (status !== "authenticated") {
    return "/welcome";
  }

  if (!isOnboardingComplete()) {
    return "/onboarding";
  }

  return "/app/today";
}

export function requireAuthPath(): "/login" | null {
  if (!isAuthEnforced()) return null;
  const { status } = useAuthStore.getState();
  if (status === "authenticated" || status === "demo") return null;
  return "/login";
}
